import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) => ({
  heading: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(1),
  },
  leftAligned: {
    paddingLeft: theme.spacing(1.5),
  },
}));

export default useStyles;
